import * as React from "react";
import { CircleCheck, Info, OctagonX, TriangleAlert } from "lucide-react";

export type StrategyPineAlertTone = "success" | "warning" | "error" | "info";

export const STRATEGY_PINE_ALERT_CLASS =
  "rounded-lg font-[family-name:var(--font-primary)]";

export function strategyPineAlertVariant(
  tone: StrategyPineAlertTone
): "success" | "warning" | "destructive" | "info" {
  switch (tone) {
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "destructive";
    default:
      return "info";
  }
}

export function StrategyPineAlertIcon({
  tone,
}: {
  tone: StrategyPineAlertTone;
}): React.ReactElement {
  switch (tone) {
    case "success":
      return <CircleCheck aria-hidden />;
    case "warning":
      return <TriangleAlert aria-hidden />;
    case "error":
      return <OctagonX aria-hidden />;
    default:
      return <Info aria-hidden />;
  }
}
